<template>
  <!-- Footer -->
  <footer class="footer-padding bg-white">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-6 my-auto">
          <img class="img-fluid" src="../../public/images/ue_logo_h50.jpg"> 
          <span class="ml-3">H2020 G.A. No 731249</span>
        </div>
        <div class="col-6 text-right my-auto">
          <span> &copy; 2024</span>
        </div>
      </div>
    </div>
  </footer>
  <!-- End of Footer -->
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer-padding{
  flex-shrink: 0;
  padding: 1rem 0;
}
</style>
